import { render, staticRenderFns } from "./Standards.vue?vue&type=template&id=76c97534&scoped=true&"
var script = {}
import style0 from "./Standards.vue?vue&type=style&index=0&id=76c97534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c97534",
  null
  
)

export default component.exports